import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/descuentos-rangos-salariales';

/**
 * GET Descuentos Rangos Salariales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDescuentosRangosSalariales = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Descuento Rango Salarial
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDescuentoRangoSalarial = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Descuento Rango Salarial
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDescuentoRangoSalarial = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Descuento Rango Salarial
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDescuentoRangoSalarial = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Descuento Rango Salarial
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDescuentoRangoSalarial = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
